module.exports = __webpack_public_path__ + "img/bitcoin-lightning.5de1e45a.png";